import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Address } from '../../../models/address';

import { AddressService } from '../../../services/contacts/address.service';
import { NotyService } from '../../../services/common/noty.service';
import { ModalService } from '../../../services/common/modal.service';

@Component({
  selector: 'app-address-index',
  templateUrl: './address-index.component.html',
  styleUrls: ['./address-index.component.scss'],
})
export class AddressIndexComponent implements OnInit, OnChanges {
  /**
   * Contact id from parent component
   */
  @Input() contactId: number;

  /**
   * Address list
   * @type {Array<Address>}
   */
  addresses: Array<Address> = [];

  /**
   * Indicates if addresses are being loaded
   * @type {boolean}
   */
  loadingAddresses: boolean = false;

  /**
   * Indicates if new address form is to be showed
   * @type {boolean}
   */
  showNewAddressForm: boolean = false;

  /**
   * Sortable options of Addresses sorting using Angular-sortablejs
   * @type {any}
   */
  sortableOptions: any = {
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ghostClass: 'sortable-ghost',
    handle: '.alias-sort-handle',
    onUpdate: (event: any) => {
      this.updateAddressesPosition();
    },
  };

  constructor(private addressService: AddressService, private modalService: ModalService, private notyService: NotyService) {}

  // Component lifecycle methods

  /**
   * Called on Component initialization
   */
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes changes containing all variables changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadAddresses();
  }

  /**
   * Delete Address
   * @param {Address} address Address to delete
   */
  deleteAddress(address: Address, index: number) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Delete Address - <strong class='text-danger'>${address.address_display}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          address.deleting = true;
          this.addressService
            .delete(address.id)
            .then((response_json) => {
              address.deleting = false;
              if (response_json.success) {
                this.notyService.notify(`Address deleted ${address.address_display}`, 'warning');
                this.addresses.splice(index, 1);
              } else this.notyService.notify(response_json.text || 'Error deleting address', 'error');
            })
            .catch(() => {
              address.deleting = false;
              this.notyService.notify('Error deleting address', 'error');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }

  /**
   * Form saved
   * @param {boolean} event Indicates if formed saved successfully
   */
  formSaved(event: boolean, address: Address | null = null) {
    if (event && !address) {
      if (!address) this.loadAddresses();
    } else if (!event && address) this.loadAddresses();
    if (!address) this.showNewAddressForm = false;
    else address.editing = false;
  }

  /**
   * Load Addresses
   */
  loadAddresses() {
    this.loadingAddresses = true;
    this.addressService
      .index({ contact_id: this.contactId })
      .then((response_json) => {
        this.loadingAddresses = false;
        this.addresses = response_json;
      })
      .catch(() => {
        this.loadingAddresses = false;
      });
  }

  /**
   * Update positions of addresses
   */
  updateAddressesPosition() {
    let addressIds: Array<number> = [];
    for (let address of this.addresses) addressIds.push(address.id);
    this.addressService
      .updatePositions(this.contactId, addressIds)
      .then((response_json) => {
        if (!response_json.success) this.notyService.notify('Error in sorting addresses', 'error');
      })
      .catch(() => {
        this.notyService.notify('Error in sorting addresses', 'error');
      });
  }
}
